const handleCorrectOrgIdInResponse = (classContext, responseData, setState, handleResponse) => {
  const thisContext = classContext;
  if (responseData.hasOwnProperty('correctOrganizationId')) {
    thisContext.setState({correctOrganizationId: responseData.correctOrganizationId});
  } else {
    handleResponse(responseData);
    thisContext.setState({correctOrganizationId: null});
  }
};
export default handleCorrectOrgIdInResponse;